__turbopack_context__.v({
  "arrow": "thumbnail-module-scss-module__d4OHdW__arrow",
  "caption-small": "thumbnail-module-scss-module__d4OHdW__caption-small",
  "figure": "thumbnail-module-scss-module__d4OHdW__figure",
  "image": "thumbnail-module-scss-module__d4OHdW__image",
  "image-medium-cover": "thumbnail-module-scss-module__d4OHdW__image-medium-cover",
  "image-skeleton": "thumbnail-module-scss-module__d4OHdW__image-skeleton",
  "image-small": "thumbnail-module-scss-module__d4OHdW__image-small",
  "image-wrapper": "thumbnail-module-scss-module__d4OHdW__image-wrapper",
  "interactive": "thumbnail-module-scss-module__d4OHdW__interactive",
  "medium": "thumbnail-module-scss-module__d4OHdW__medium",
  "medium-contain": "thumbnail-module-scss-module__d4OHdW__medium-contain",
  "playBtnContainer": "thumbnail-module-scss-module__d4OHdW__playBtnContainer",
  "read": "thumbnail-module-scss-module__d4OHdW__read",
  "small": "thumbnail-module-scss-module__d4OHdW__small",
  "subtitle": "thumbnail-module-scss-module__d4OHdW__subtitle",
  "subtitle-color-future-fuscia": "thumbnail-module-scss-module__d4OHdW__subtitle-color-future-fuscia",
  "tagContainer": "thumbnail-module-scss-module__d4OHdW__tagContainer",
  "title": "thumbnail-module-scss-module__d4OHdW__title",
  "watch": "thumbnail-module-scss-module__d4OHdW__watch",
});
